import { createFileRoute } from "@tanstack/react-router";
import { SubscriptionSuccess } from "@/lib/lazyPages";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/subscription/success-assessment")({
  head: () => seoHead({
    title: "Assessment Unlocked",
    description: "Your LeadXkids personality assessment is unlocked.",
    noindex: true,
  }),
  component: () => <SubscriptionSuccess variant="assessment" />,
});
